/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_td_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free text diff tool. Compare two blocks of text line by line and see what was added or removed. Runs in your browser.`)
};

const es_td_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramienta gratuita de comparación de textos. Compara dos bloques de texto línea por línea y ve qué se agregó o se eliminó. Se ejecuta en tu navegador.`)
};

const de_td_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloses Text-Diff-Tool. Vergleiche zwei Textblöcke Zeile für Zeile und sehe, was hinzugefügt oder entfernt wurde. Läuft in deinem Browser.`)
};

const nl_td_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis tekstdiff-tool. Vergelijk twee blokken tekst regel voor regel en zie wat er is toegevoegd of verwijderd. Draait in uw browser.`)
};

const fr_td_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outil gratuit de diff textuel. Comparez deux blocs de texte ligne par ligne et voyez ce qui a été ajouté ou supprimé. S'exécute dans votre navigateur.`)
};

const it_td_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumento gratuito di confronto testi. Confronta due blocchi di testo riga per riga e vedi cosa è stato aggiunto o rimosso. Funziona nel tuo browser.`)
};

const pt_br2_td_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta gratuita de diferenças de texto. Compare dois blocos de texto linha por linha e veja o que foi adicionado ou removido. Executado no seu navegador.`)
};

const pt_td_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta gratuita de comparação de texto. Compare dois blocos de texto linha a linha e veja o que foi adicionado ou removido. Funciona no seu navegador.`)
};

const ja_td_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のテキスト差分ツール。2つのテキストブロックを行ごとに比較し、追加または削除された内容を確認します。ブラウザで実行されます。`)
};

const zh_td_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的文本比较工具。逐行比较两段文本，查看新增或删除的内容。在你的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const td_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.td_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("td_tool_description", locale)
	if (locale === "en") return en_td_tool_description(inputs)
	if (locale === "es") return es_td_tool_description(inputs)
	if (locale === "de") return de_td_tool_description(inputs)
	if (locale === "nl") return nl_td_tool_description(inputs)
	if (locale === "fr") return fr_td_tool_description(inputs)
	if (locale === "it") return it_td_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_td_tool_description(inputs)
	if (locale === "pt") return pt_td_tool_description(inputs)
	if (locale === "ja") return ja_td_tool_description(inputs)
	return zh_td_tool_description(inputs)
};